module.exports = __webpack_public_path__ + "img/Background8.03f89be0.jpg";